import get from './methods/get';

export default {
	get: (headers) => get('weather', headers),
	emptyResponse: {},
};
